export interface LatestRequestGuard {
  begin: () => number;
  isCurrent: (request: number) => boolean;
  invalidate: () => void;
}

export function createLatestRequestGuard(): LatestRequestGuard {
  let currentRequest = 0;
  return {
    begin: () => {
      currentRequest += 1;
      return currentRequest;
    },
    isCurrent: (request) => request === currentRequest,
    invalidate: () => {
      currentRequest += 1;
    },
  };
}
